/* The generation-2 pipe envelope — the field-escaping rule every phone→TV QR
   payload shares (docs/imp-docs/no-network-wifi/QR-WC-FORMAT.md §2).

   Every code has the shape `|TYPE|VERSION|field|field|…|`, so a field whose own
   text contains a delimiter has to be escaped: backslash first (\ -> \\), then
   pipe (| -> \|). The order matters — escaping the pipe first would
   double-escape the backslashes it introduces. The device unescapes in the
   mirror order.

   This lives in its own module because it belongs to the ENVELOPE rather than
   to any one payload type: WC (WiFi credentials, wcCode.js) and RS (reset,
   rsCode.js) are both built on it, and any later type will be too. The format
   is frozen; a change to it is a version bump, never a mutation. */

export function escapeEnvelopeField(value) {
  return value.replace(/\\/g, '\\\\').replace(/\|/g, '\\|');
}
